import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { get } from "lodash";
import { Tabs, Tab } from "react-bootstrap";
import { NotificationManager } from "react-notifications";

import { getRecipeDetails, publishRecipe } from "../../../../store/actions";
import { recipeSteps } from "./formHelper";

const AddRecipeTabs = ({ recipeDetails, match, getRecipeDetails, publishRecipe, history }) => {
	const [activeTab, setActiveTab] = useState(0);

	useEffect(() => {
		if (match && match.params && match.params.id) {
			if (Number(match.params.id) !== Number(recipeDetails.id)) {
				getRecipeDetails(match.params.id);
			}
		}
	}, [recipeDetails, match, getRecipeDetails]);

	const [newItems, setNewItems] = useState({ ingredients: false, categories: false, sources: false, images: false });
	const newAdditions = (label, data) => {
		newItems[label] !== data && setNewItems({ ...newItems, [label]: data });
	};

	const saveAndPublish = (shouldCheck = true) => {
		const recipeId = match.params.id;
		getRecipeDetails(recipeId, (event) => {
			event.json().then((data) => {
				const noIngredients = data.ingredients.length === 0;
				const noCategories = data.categories.length === 0;
				const noSources = data.main_sources.length === 0;
				const noImage = data.images.length === 0;

				const successHandler = (event) => {
					NotificationManager.success("Recipe saved!", "", 5000);
					history.push(`/nutrition/recipes/${recipeId}/details`);
				};

				if (noIngredients) {
					setActiveTab(1);
					NotificationManager.error("Please add some ingredients!", "", 5000);
				} else if (noCategories) {
					setActiveTab(2);
					NotificationManager.error("Please add some categories!", "", 5000);
				} else if (noSources) {
					setActiveTab(3);
					NotificationManager.error("Please add some sources!", "", 5000);
				} else if (noImage) {
					setActiveTab(4);
					NotificationManager.error("Please add some images!", "", 5000);
				} else if (shouldCheck) {
					if (newItems.ingredients) {
						setActiveTab(1);
						NotificationManager.error("Please save ingredients!", "", 5000);
					} else if (newItems.categories) {
						setActiveTab(2);
						NotificationManager.error("Please save categories!", "", 5000);
					} else if (newItems.sources) {
						setActiveTab(3);
						NotificationManager.error("Please save sources!", "", 5000);
					} else if (newItems.images) {
						setActiveTab(4);
						NotificationManager.error("Please save images!", "", 5000);
					} else {
						publishRecipe(recipeId, successHandler);
					}
				} else {
					publishRecipe(recipeId, successHandler);
				}
			});
		});
	};

	const renderTabs = () => {
		return recipeSteps.map((step, i) => {
			const SpecificStep = step.component;
			return (
				<Tab key={step.id} eventKey={i} title={step.title} disabled={!recipeDetails.id}>
					<SpecificStep
						setActiveTab={setActiveTab}
						initialValues={recipeDetails}
						saveAndPublish={saveAndPublish}
						refetchRecipe={() => getRecipeDetails(recipeDetails.id)}
						history={history}
						match={match}
						newAdditions={newAdditions}
					/>
				</Tab>
			);
		});
	};

	return (
		<React.Fragment>
			<Tabs activeKey={activeTab} className="pt-2" onSelect={(tabNumber) => setActiveTab(Number(tabNumber))}>
				{renderTabs()}
			</Tabs>
			<div className="tab-status-text">Step {`${activeTab + 1} - ${recipeSteps.length}`}</div>
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	return {
		recipeDetails: get(state, "Recipes.recipeDetails", {})
	};
};

const mapDispatchToProps = { getRecipeDetails, publishRecipe };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(AddRecipeTabs));
